import React, { useState, useEffect, useRef } from 'react';
import "./ProjectOverview.css";
import { DateRangePicker } from "rsuite";
import { useSelector, useDispatch } from "react-redux";
import { AES, enc } from 'crypto-js';
import { Link, useParams } from 'react-router-dom';
import moment from "moment";
import TimeIccon from "../../../../images/icons/clock.svg";
import DollarIccon from "../../../../images/icons/billable.svg";
import CloseDollarIccon from "../../../../images/icons/non-billable.svg";
import PurseMmoney from "../../../../images/icons/purses-money.svg";
import NotepadIcon from "../../../../images/icons/notepad.svg";
import DollarReverse from "../../../../images/icons/dollar-reverse.svg";
import { setClientDashboardDate } from '../../../../features/client/clientSlice';


const ProjectOverview = (props) => {
    const dispatch = useDispatch();
    const { forex } = useSelector((state) => state.forex);
    const settings = JSON.parse(localStorage.getItem("settings"));

    const [selectedRange, setSelectedRange] = useState([]);
    const token = useSelector((state) => state.auth.token);
    const dashboradDate = useSelector((state) => state.client.dashboardDateRange);
    const { projectAdded } = useSelector((state) => state.project);

    const { appSettings } = useSelector((state) => state.appSettings);
    const startDate = props.dateRange && props.dateRange[0];
    const endDate = props.dateRange && props.dateRange[1];
    
    // Animation states
    const [displayedTotalDuration, setDisplayedTotalDuration] = useState(0);
    const [displayedBillable, setDisplayedBillable] = useState(0);
    const [displayedNonBillable, setDisplayedNonBillable] = useState(0);
    const [displayedBudget, setDisplayedBudget] = useState(0);
    const [displayedCost, setDisplayedCost] = useState(0);
    
    // Animation refs
    const totalDurationRef = useRef(null);
    const billableRef = useRef(null);
    const nonBillableRef = useRef(null);
    const budgetRef = useRef(null);
    const costRef = useRef(null);
    
    useEffect(() => {
    }, [props.clientIds, props.dateRange, dashboradDate, projectAdded]);
    
    // Animate Total Duration
    useEffect(() => {
        if (totalDurationRef.current) {
            cancelAnimationFrame(totalDurationRef.current);
        }
        
        const targetValue = props.totalDuration ? parseFloat(props.totalDuration) : 0;
        const startValue = displayedTotalDuration;
        const duration = 1000;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentValue = startValue + (targetValue - startValue) * easeOut;
            setDisplayedTotalDuration(Math.floor(currentValue));
            
            if (progress < 1) {
                totalDurationRef.current = requestAnimationFrame(animate);
            } else {
                setDisplayedTotalDuration(targetValue);
                totalDurationRef.current = null;
            }
        };
        
        if (Math.abs(startValue - targetValue) > 0.01) {
            totalDurationRef.current = requestAnimationFrame(animate);
        }
        
        return () => {
            if (totalDurationRef.current) {
                cancelAnimationFrame(totalDurationRef.current);
            }
        };
    }, [props.totalDuration]);
    
    // Animate Billable Duration
    useEffect(() => {
        if (billableRef.current) {
            cancelAnimationFrame(billableRef.current);
        }
        
        const targetValue = props.calculateTotalDurationBillable ? parseFloat(props.calculateTotalDurationBillable) : 0;
        const startValue = displayedBillable;
        const duration = 1000;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentValue = startValue + (targetValue - startValue) * easeOut;
            setDisplayedBillable(Math.floor(currentValue));
            
            if (progress < 1) {
                billableRef.current = requestAnimationFrame(animate);
            } else {
                setDisplayedBillable(targetValue);
                billableRef.current = null;
            }
        };
        
        if (Math.abs(startValue - targetValue) > 0.01) {
            billableRef.current = requestAnimationFrame(animate);
        }
        
        return () => {
            if (billableRef.current) {
                cancelAnimationFrame(billableRef.current);
            }
        };
    }, [props.calculateTotalDurationBillable]);
    
    // Animate Non-Billable Duration
    useEffect(() => {
        if (nonBillableRef.current) {
            cancelAnimationFrame(nonBillableRef.current);
        }
        
        const targetValue = props.calculateTotalDurationNonBillable ? parseFloat(props.calculateTotalDurationNonBillable) : 0;
        const startValue = displayedNonBillable;
        const duration = 1000;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentValue = startValue + (targetValue - startValue) * easeOut;
            setDisplayedNonBillable(Math.floor(currentValue));
            
            if (progress < 1) {
                nonBillableRef.current = requestAnimationFrame(animate);
            } else {
                setDisplayedNonBillable(targetValue);
                nonBillableRef.current = null;
            }
        };
        
        if (Math.abs(startValue - targetValue) > 0.01) {
            nonBillableRef.current = requestAnimationFrame(animate);
        }
        
        return () => {
            if (nonBillableRef.current) {
                cancelAnimationFrame(nonBillableRef.current);
            }
        };
    }, [props.calculateTotalDurationNonBillable]);
    
    // Animate Budget
    useEffect(() => {
        if (budgetRef.current) {
            cancelAnimationFrame(budgetRef.current);
        }
        
        const targetValue = props.totalBudget ? parseFloat(props.totalBudget) : 0;
        const startValue = displayedBudget;
        const duration = 1000;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentValue = startValue + (targetValue - startValue) * easeOut;
            setDisplayedBudget(parseFloat(currentValue.toFixed(2)));
            
            if (progress < 1) {
                budgetRef.current = requestAnimationFrame(animate);
            } else {
                setDisplayedBudget(targetValue);
                budgetRef.current = null;
            }
        };
        
        if (Math.abs(startValue - targetValue) > 0.01) {
            budgetRef.current = requestAnimationFrame(animate);
        }
        
        return () => {
            if (budgetRef.current) {
                cancelAnimationFrame(budgetRef.current);
            }
        };
    }, [props.totalBudget]);
    
    // Animate Cost
    useEffect(() => {
        if (costRef.current) {
            cancelAnimationFrame(costRef.current);
        }
        
        const targetValue = props.totalCost ? parseFloat(props.totalCost) : 0;
        const startValue = displayedCost;
        const duration = 1000;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentValue = startValue + (targetValue - startValue) * easeOut;
            setDisplayedCost(parseFloat(currentValue.toFixed(2)));
            
            if (progress < 1) {
                costRef.current = requestAnimationFrame(animate);
            } else {
                setDisplayedCost(targetValue);
                costRef.current = null;
            }
        };
        
        if (Math.abs(startValue - targetValue) > 0.01) {
            costRef.current = requestAnimationFrame(animate);
        }
        
        return () => {
            if (costRef.current) {
                cancelAnimationFrame(costRef.current);
            }
        };
    }, [props.totalCost]);

    const handleDateRangeChange = async (value) => {
        if (value === null) {
            var newDate = [
                moment().tz(global.config.getTimeZone()).startOf('year').format('YYYY/MM/DD HH:mm'),
                moment().tz(global.config.getTimeZone()).endOf('year').format('YYYY/MM/DD HH:mm')
            ];
            setSelectedRange(newDate);
        } else {
            setSelectedRange(value);
            await dispatch(setClientDashboardDate(value));
        }
    };

    const changeDurationFormat = (sec) => {
        let second = sec;
        const hours = Math.floor(second / 3600);
        const minutes = Math.floor((second % 3600) / 60);
        const seconds = second % 60;
        const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        return formattedDuration;
    }

    const Roi = (Cbudget, cCost) => {
        const budget = Cbudget;
        const cost = cCost;
        if (cost === 0 && budget === 0) {
            return "0%";
        } else if (cost === 0 && budget !== 0) {
            return "N/A";
        } else {
            const rev = budget - cost;
            const Rvalue = (rev / cost) * 100;
            return isNaN(Rvalue) ? "0%" : Rvalue.toFixed(2) + "%";
        }
    }

    return (
        <>
            <style>
                {`
                    @keyframes pulse {
                        0%, 100% {
                            opacity: 1;
                        }
                        50% {
                            opacity: 0.5;
                        }
                    }
                `}
            </style>
            <div className="client-activities-outer">
            <div className="client-activity-columns">
                <div className="activity-column">
                    <div className="activity-with-image">
                        <div className="activity-name">
                            Total Hours
                        </div>
                        <img src={TimeIccon} alt="time-iccon" />
                    </div>
                    <div className="activity-count">
                        {props.totalCostLoading ? (
                            <div
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                }}
                            />
                        ) : (
                            <span>{changeDurationFormat(displayedTotalDuration)}</span>
                        )}
                    </div>
                </div>
                <div className="activity-column">
                    <div className="activity-with-image">
                        <div className="activity-name">
                            Total Billable
                        </div>
                        <img src={DollarIccon} alt="dollar-iccon" />
                    </div>
                    <div className="activity-count">
                        {props.totalCostLoading ? (
                            <div
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                }}
                            />
                        ) : (
                            <span>{changeDurationFormat(displayedBillable)}</span>
                        )}
                    </div>
                </div>
                <div className="activity-column">
                    <div className="activity-with-image">
                        <div className="activity-name">
                            Total Non-Billable
                        </div>
                        <img src={CloseDollarIccon} alt="close-dollar-iccon" />
                    </div>
                    <div className="activity-count">
                        {props.totalCostLoading ? (
                            <div
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                }}
                            />
                        ) : (
                            <span>{changeDurationFormat(displayedNonBillable)}</span>
                        )}
                    </div>
                </div>
                <div className="activity-column">
                    <div className="activity-with-image">
                        <div className="activity-name">
                            Total Budget
                        </div>
                        <img src={PurseMmoney} alt="purses-of-money" />
                    </div>
                    <div className="activity-count">
                        {props.totalCostLoading ? (
                            <div
                                style={{
                                    width: "150px",
                                    height: "40px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                }}
                            />
                        ) : (
                            settings.currency ? (
                                props.totalBudget ?
                                    new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: settings.currency,
                                    }).format(displayedBudget)
                                    :
                                    new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: settings?.currency,
                                    }).format("0.00")
                            ) : (
                                props.totalBudget ?
                                    new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: 'USD',
                                    }).format(displayedBudget) :
                                    new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: 'USD',
                                    }).format('0.00')
                            )
                        )}
                    </div>
                </div>
                <div className="activity-column">
                    <div className="activity-with-image">
                        <div className="activity-name">
                            Total Cost
                        </div>
                        <img src={NotepadIcon} alt="notepad-iccon" />
                    </div>
                    <div className="activity-count">
                        {props.totalCostLoading ? (
                            <div
                                style={{
                                    width: "150px",
                                    height: "40px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                }}
                            />
                        ) : (
                            settings.currency ? (
                                props.totalCost ?
                                    new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: settings.currency,
                                    }).format(displayedCost)
                                    :
                                    new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: settings?.currency,
                                    }).format("0.00")
                            ) : (
                                props.totalCost ? displayedCost.toFixed(2) : '0.00'
                            )
                        )}
                    </div>
                </div>
                <div className="activity-column">
                    <div className="activity-with-image">
                        <div className="activity-name">
                            ROI
                        </div>
                        <img src={DollarReverse} alt="time-iccon" />
                    </div>
                    <div className="activity-count">
                        {props.totalCostLoading ? (
                            <div
                                style={{
                                    width: "80px",
                                    height: "40px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                }}
                            />
                        ) : (
                            Roi(displayedBudget, displayedCost)
                        )}
                    </div>
                </div>

            </div>
        </div>
        </>
    )
};

export default ProjectOverview; 